<template>
  <BaseDialog
    :is-visible="true"
    class="cfe-hide-trainer-dialog full-screen"
    width="960px"
    :title="$t('mbti.cfe.hideTrainer.title')"
    :subtitle="$t('mbti.cfe.hideTrainer.subtitle')"
    @close-dialog="$emit('close-dialog', true)"
  >
    <template #footer>
      <div
        v-loading="isBtnShowLoading"
        class="btn btn-show"
        @click="setTrainerDislikeSetting(false)"
      >
        {{ isBtnShowLoading ? '' : $t('mbti.cfe.hideTrainer.showTrainer') }}
      </div>
      <div
        v-loading="isBtnHideLoading"
        class="btn btn-hide"
        @click="setTrainerDislikeSetting(true)"
      >
        {{ isBtnHideLoading ? '' : $t('mbti.cfe.hideTrainer.doNotShowTrainer') }}
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { getApiMethod } from '@/modules/apiSelector';

import BaseDialog from '@/components/Base/Dialog';

export default {
  components: { BaseDialog },
  data() {
    return {
      loadingButtonValue: null
    };
  },
  computed: {
    ...mapState(['teacherId']),

    isBtnShowLoading() {
      return this.loadingButtonValue === false;
    },

    isBtnHideLoading() {
      return this.loadingButtonValue === true;
    }
  },
  methods: {
    ...mapMutations('modal', ['setShowCfeConfirmation', 'setShowCfeHideTrainerModal']),

    async setTrainerDislikeSetting(setting) {
      if (this.loadingButtonValue !== null) {
        return;
      }

      this.loadingButtonValue = setting;

      const variables = {
        teacher_id: this.teacherId,
        setting
      };

      const apiMethod = getApiMethod('updateDislikeSetting');
      await apiMethod(
        variables, 
        () => {
          this.setShowCfeHideTrainerModal(false);
          this.setShowCfeConfirmation(true);
        },
        (error) => {
          this.$logger.debug('[trainer_dislike_setting] Something went wrong: ', error);
        }
      );

      this.loadingButtonValue = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.cfe-hide-trainer-dialog ::v-deep {
  .title {
    margin-top: 24px;
    @media screen and (max-width: 959px) {
      line-height: 27px !important;
      white-space: pre;
    }
  }

  .subtitle {
    margin-top: 24px !important;
    margin-bottom: 24px;
    line-height: 18px !important;
  }

  .btn {
    display: flex;
    border-radius: 8px;
    width: 240px;
    max-width: 382px;
    padding: 16px 0px;
    box-sizing: border-box;
    min-height: 56px;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    user-select: none;

    &.btn-show {
      border: 1px solid #0087d2;
      background: #ffffff;
      color: #0087d2;
      margin-right: 24px;

      @media screen and (max-width: 498px) {
        margin-right: 8px;
      }
    }

    &.btn-hide {
      background: #0087d2;
      color: #ffffff;
      .el-loading-spinner .path {
        stroke: #fff;
      }
    }

    .el-loading-mask {
      background-color: rgba(255, 255, 255, 0.3) !important;
    }

    .el-loading-spinner {
      .circular {
        width: 38px;
        height: 38px;
      }
    }
  }

  .body-scrollbar {
    @media screen and (max-width: 498px) {
      display: flex;
      align-items: center;
      justify-content: center;
      justify-items: center;
      flex-direction: column;
    }
  }
}
</style>
